var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { buildMultilingualLink } from '../../types/builders';
export function getMultilingualSchemaFromContext(data) {
    var _a = (data || {}).context, _b = _a === void 0 ? {} : _a, siteLanguages = _b.siteLanguages, siteUrl = _b.siteUrl;
    if (!(siteLanguages === null || siteLanguages === void 0 ? void 0 : siteLanguages.length)) {
        return { tags: [] };
    }
    var languages = __spreadArrays(siteLanguages, [
        { url: siteUrl, languageCode: 'x-default' },
    ]);
    var tags = getMultilingualTags(languages);
    return { tags: tags };
}
/**
 *
 * @param {Array<{
 * url: string,
 * langCode: string,
 * languageCode: string
 * }>} siteLanguages
 */
export function getMultilingualTags(siteLanguages) {
    return (siteLanguages || [])
        .map(function (_a) {
        var url = _a.url, linkToPage = _a.linkToPage, langCode = _a.langCode, languageCode = _a.languageCode, language = _a.language;
        url = url || linkToPage;
        langCode = langCode || languageCode || language;
        var tag = url && langCode ? buildMultilingualLink(url, langCode) : undefined;
        return tag;
    })
        .filter(Boolean);
}
